<template>
  <section class="hero is-fullheight faq-page">
    <PmNavbar />
    <div class="hero-body">
      <div class="container">
        <div class="columns is-multiline p-5">
          <div class="column is-12">
            <h2 class="mb-3 is-ubuntu font-28">Tietosuojaseloste</h2>

            <h3 class="mt-5 mb-3 is-ubuntu font-20">Rekisterinpitäjä</h3>

            <p class="font-18">Pyroll Kuitupakkaukset Oy, 0159902-7</p>
            <p class="font-18 mt-5">Rekisteriasioissa yhteyshenkilönä toimii:</p>
            <p class="font-18">Mauri Reinilä</p>
            <p class="font-18">Pyroll Kuitupakkaukset Oy</p>
            <p class="font-18">Kalliotie 2</p>
            <p class="font-18">FI-04360 Tuusula</p>
            <p class="font-18">
              <a href="mailto:mauri.reinila@pyroll.com">mauri.reinila@pyroll.com</a>
            </p>

            <h3 class="mt-5 is-ubuntu font-20">Henkilötietojen käsittelyn tarkoitus</h3>

            <p class="font-18">
              Henkilötietoja käsitellään asiakassuhteeseen liittyvien asioiden hoitamiseen ja hallinnointiin
              (tuotteiden ja palveluiden tarjoaminen, myynti, toimittaminen ja laskuttaminen, sekä mahdollisten
              tukipyyntöjen ja reklamaatioiden käsittelyyn).
            </p>

            <p class="font-18">Tietoja ei luovuteta ulkopuolisille.</p>

            <h3 class="mt-5 is-ubuntu font-20">Käsiteltävät henkilötietoryhmät</h3>

            <p class="font-18">
              Henkilön perustiedot ja yhteystiedot (etunimi, sukunimi, sähköpostiosoite, puhelinnumero, työnantaja ja
              työtehtävä)
            </p>

            <h3 class="mt-5 is-ubuntu font-20">Säännönmukaiset tietolähteet</h3>
            <p class="font-18">Henkilötietoja kerätään rekisteröidyiltä itseltään.</p>

            <h3 class="mt-5 is-ubuntu font-20">Henkilötietojen säilytysaika</h3>

            <p class="font-18">
              Tietoja säilytetään niin kauan ja siinä laajuudessa kuin on tarpeellista suhteessa tarkoitukseen, johon
              henkilötiedot on kerätty (esim. asiakassuhde, tarjotut ratkaisut / palvelut, uutiskirjeen tilaus).
            </p>

            <p>Minimissään tietoja säilytetään lain määrittämän ajan.</p>

            <p class="font-18">
              Tietoja ei luovuteta kolmansille osapuolille. Tietoja voidaan kuitenkin luovuttaa viranomaisten
              lakisääteisten tietojen luovutuspyyntöjen mukaisesti.
            </p>

            <h3 class="mt-5 is-ubuntu font-20">Tietojen siirto EU:n tai ETA:n ulkopuolelle</h3>

            <p class="font-18">Henkilötietoja ei lähtökohtaisesti siirretä EU:n tai ETA:n ulkopuolelle.</p>

            <p class="font-18">
              Tiettyjen tuotteiden ja palveluiden toimittaminen edellyttää tietojen siirtämistä EU:n ulkopuolelle,
              näitä palveluita ovat:
            </p>

            <ul>
              <li class="font-18">Verkkosivuston analytiikka: Google Analytics ja Microsoft Clarity (Yhdysvallat)</li>
            </ul>

            <p class="font-18">
              Siirtojen perusteena on Euroopan komission hyväksymät vakiolausekkeet. Olemme arvioineet ettei tietojen
              siirto näiden em. palveluiden osalta vaaranna henkilötietoja.
            </p>

            <h3 class="mt-5 is-ubuntu font-20">Rekisterin suojauksen periaatteet</h3>

            <p class="font-18">
              Henkilötietoja sisältävät tietokannat ovat palvelimella, jota säilytetään lukitussa tilassa, johon on
              pääsy ainoastaan nimetyillä ja tehtäviensä vuoksi pääsyyn valtuutetuilla henkilöillä. Palvelin on
              suojattu asianmukaisella palomuurilla ja teknisellä suojauksella.
            </p>

            <p class="font-18">
              Tietokantoihin ja järjestelmiin on pääsy vain erikseen myönnettävillä henkilökohtaisilla
              käyttäjätunnuksilla ja salasanoilla. Rekisterinpitäjä on rajannut käyttöoikeudet ja -valtuudet
              tietojärjestelmiin ja muihin tallennusalustoihin siten, että tietoja pääsevät tarkastelemaan ja
              käsittelemään ainoastaan niiden lainmukaisen käsittelyn kannalta tarpeelliset henkilöt.
            </p>

            <p class="font-18">
              Rekisterinpitäjän työntekijät ja muut henkilöt ovat erillisellä sopimuksella sitoutuneet noudattamaan
              vaitiolovelvollisuutta ja pitämään salassa henkilötietojen käsittelyn yhteydessä saamansa tiedot.
            </p>

            <h3 class="mt-5 is-ubuntu font-20">Rekisteröidyn oikeudet</h3>

            <p class="font-18">
              Rekisteröidyllä on seuraavat EU:n yleisen tietosuoja-asetuksen mukaiset oikeudet:
            </p>

            <ul>
              <li class="font-18">
                Tarkastusoikeus: rekisteröidyllä on oikeus tarkastaa rekisteröityä koskevat tiedot ja vaatia
                mahdollisten virheiden korjaamista ja täydentämistä.
              </li>
              <li class="font-18">
                Vastustamisoikeus: rekisteröidyllä on oikeus vastustaa tietojen käsittelyä, mikäli tietoja on käsitelty
                lainvastaisesti tai luvattomasti.
              </li>
              <li class="font-18">
                Poisto-oikeus: rekisteröidyllä on oikeus pyytää poistamaan rekisteröityä koskevat henkilötiedot siltä
                osin kuin ne eivät oli rekisterinpitäjän tehtävien kannalta tarpeellisia.
              </li>
              <li class="font-18">
                Siirto-oikeus: rekisteröidyllä on oikeus saada itseään koskevat siirrettävät henkilötiedot koneellisesti
                siirrettävässä muodossa toimitettavaksi toiselle rekisterinpitäjälle, mikäli kyseessä on
                tietosuojalainsäädännön perusteella siirrettävät tiedot.
              </li>
              <li class="font-18">
                Valitusoikeus: Rekisteröidyllä on oikeus tehdä valitus tietosuojavaltuutetulle, jos rekisteröity katsoo
                rekisterinpitäjän rikkoneen voimassa olevaa tietosuojalainsäädäntöä henkilötietojen käsittelyssä.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <PmFooter />
  </section>  
</template>

<script>
import PmNavbar from "../components/PmNavbar";
import PmFooter from "../components/PmFooter";

export default {
  name: "FaqPage",
  components: {
    PmNavbar,
    PmFooter,
  },
  data() {
    return {}
  },
  methods: {},
  mounted() {},
  computed: {},
}
</script>

<style scoped lang="scss">
@use '../assets/sass/variables' as *;
.faq-page {
  .img-container {
    height: 150px;
    flex-grow: 1;
  }
  .cstm-icon {
    height: 80px;
  }  
}
</style>
